module.exports = __webpack_public_path__ + "static/img/cpzx.6e202f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cpzx.jpg
// module id = kOOf
// module chunks = 1